/*
    Should be rendered within DrawerContainer
    Closes the drawer container

    allows for title to past through when rendering the snippet
    the title can be any form of html
    see side cart for example

*/


import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class DrawerHeader extends ThemeComponent {
    @Ref closeButton!: HTMLButtonElement;

    private close: string = '';
    private _onCloseChange = new SimpleEvent<string>();

    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    public changeClose(close: string) {
        this.close = close;

        // Use the private backing field to dispatch
        this._onCloseChange.dispatch(close);
    }

    /** Initialise component */
    init(): void {
        const cartDrawer = document.querySelector('.side-cart__drawer') as HTMLElement | null;
        const filterDrawer = document.querySelector('.filter-drawer') as HTMLElement | null;

        document.addEventListener('click', (event: MouseEvent) => {
            const boolIsInside = cartDrawer?.contains(event.target as Node);
            const boolIsFilterInside = filterDrawer?.contains(event.target as Node);

            const target = event.target as HTMLElement;
            const isButton = target.closest('button');
            const isInput = target.closest('input');
            // Check if you click a button, in that case, event is ignored
            if (isButton || isInput) {
                return;
            } else {
            // Check if you click the cart drawer or filter drawer to prevent closing them when using
                if (!boolIsInside && !boolIsFilterInside) {
                    this._onCloseChange.dispatch(this.close);
                }
            }
        });

        this.$listen(this.closeButton, 'click', () => {
            this._onCloseChange.dispatch(this.close);
        });
    }
}
